import styles from "./Fifth.module.css";
import { useState, useEffect } from "react";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

function Fifth() {
  const skills = [
    { id: "1", name: "Python", image: "/images/skills/python.png" },
    { id: "2", name: "HuggingFace", image: "/images/skills/HuggingFace.png" },
    { id: "3", name: "LangChain", image: "/images/skills/LanChain.png" },
    { id: "4", name: "Java", image: "/images/skills/java.png" },
    { id: "5", name: "MySQL", image: "/images/skills/mysql.png" },
    { id: "6", name: "React", image: "/images/skills/react.png" },
    { id: "7", name: "Angular", image: "/images/skills/angular.png" },
    { id: "8", name: "JavaScript", image: "/images/skills/js.png" },
    { id: "9", name: "SpringBoot", image: "/images/skills/spring.png" },
    { id: "10", name: "Docker", image: "/images/skills/docker.png" },
    { id: "11", name: "Kubernetes", image: "/images/skills/kubernetes.png" },
    { id: "12", name: "Html 5", image: "/images/skills/html.png" },
    { id: "13", name: "CSS 3", image: "/images/skills/css.png" },
    { id: "14", name: "Nodejs", image: "/images/skills/node.png" },
    { id: "15", name: "MongoDB", image: "/images/skills/mongodb.png" },
    
  ];

  const [animation, setAnimation] = useState("right");
  const [counter, setCounter] = useState(5);
  const [skillsNumber, setSkillsNumber] = useState(5);

  const rightClickHandler = () => {
    if (counter === skills.length) {
      setCounter(skillsNumber);
    } else {
      setCounter(counter + 1);
    }
    setAnimation("right");
  };
  const leftClickHandler = () => {
    if (counter === skillsNumber) {
      setCounter(skills.length);
    } else {
      setCounter(counter - 1);
    }
    setAnimation("left");
  };

  //this is for changing the number of displayed skills depending on the view width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const detectSize = () => {
    setWindowWidth(window.innerWidth);
  };

  //to detect the view width using window object
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    if (windowWidth <= 600) {
      setSkillsNumber(2);
      setCounter(2);
    }
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowWidth]);

  return (
    <div className={styles.skills}>
      <KeyboardDoubleArrowLeftIcon
        onClick={leftClickHandler}
        sx={{ fontSize: 50, color: "#00ADB5", cursor: "pointer" }}
      />
      <div className={styles.logos}>
        {skills.slice(counter - skillsNumber, counter).map((element) => (
          <div
            key={element.id}
            className={`${styles.skill} ${
              animation === "right" ? styles.leftskill : styles.rightskill
            }`}
          >
            <img src={element.image} alt={element.name} />
            <h4>{element.name}</h4>
          </div>
        ))}
      </div>
      <KeyboardDoubleArrowRightIcon
        onClick={rightClickHandler}
        sx={{ fontSize: 50, color: "#00ADB5", cursor: "pointer" }}
      />
    </div>
  );
}
export default Fifth;
